import { Check, X } from "lucide-react";

import {
  formatPcrsValue,
  isNoValue,
  isYesValue,
  PCRS_EMPTY_PLACEHOLDER,
} from "features/cdm/utils/pcrsDetails";

import styles from "./DetailItem.module.css";

const DetailValue = ({ value, fieldKey }) => {
  if (isYesValue(value)) {
    return (
      <span className={`${styles.pill} ${styles.pillYes}`}>
        <Check size={13} aria-hidden />
        Yes
      </span>
    );
  }

  if (isNoValue(value)) {
    return (
      <span className={`${styles.pill} ${styles.pillNo}`}>
        <X size={13} aria-hidden />
        No
      </span>
    );
  }

  const formatted = formatPcrsValue(value, fieldKey);

  return (
    <span className={formatted === PCRS_EMPTY_PLACEHOLDER ? styles.muted : undefined}>
      {formatted}
    </span>
  );
};

export const DetailItem = ({ label, value, fieldKey }) => (
  <div className={styles.item}>
    <span className={styles.label}>{label}</span>
    <span className={styles.value}>
      <DetailValue value={value} fieldKey={fieldKey} />
    </span>
  </div>
);
